import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { FiHash, FiMail, FiPhone } from 'react-icons/fi';

/**
 * Every identifier a message log row was addressed by. A send can target a phone,
 * an email, an external_id, or any mix — rows sent by external_id alone have no
 * phone, so showing only `to` left them blank.
 *
 * Different screens get differently shaped rows (`to` on /msg-log/list, `sent_to`
 * on flow logs, `recipient` on campaign reports), so the phone falls back across them.
 * A bare recipient that is actually an email address is shown as one.
 */
export const recipientsOf = (row) => {
  const address = row?.to || row?.sent_to || row?.recipient;
  const addressIsEmail = typeof address === 'string' && address.includes('@');
  const email = row?.email || (addressIsEmail ? address : '');
  const phone = addressIsEmail ? '' : address;

  return [
    { label: 'Phone', icon: FiPhone, value: phone },
    { label: 'Email', icon: FiMail, value: email },
    { label: 'External ID', icon: FiHash, value: row?.external_id },
  ].filter((r) => r.value);
};

const RecipientInfo = ({ row, fontSize = 'xs' }) => {
  const recipients = recipientsOf(row);
  if (recipients.length === 0) return <Text fontSize={fontSize}>—</Text>;

  return (
    <VStack align="start" spacing={0}>
      {recipients.map((r) => (
        <HStack key={r.label} spacing={1.5} title={r.label}>
          <Icon as={r.icon} boxSize="12px" color="gray.500" flexShrink={0} />
          <Text fontSize={fontSize} fontWeight="semibold">{r.value}</Text>
        </HStack>
      ))}
    </VStack>
  );
};

export default RecipientInfo;
